import { Box } from '@mui/material'
import { FC } from 'react'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-pro'

interface SeoOptimizationsProps {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
}

const SeoOptimizationCell: FC<SeoOptimizationsProps> = ({ params }) => {
  const { org_uuid: _org_uuid, isParent, PK: _PK, SK: _SK } = params?.row ?? {}

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      {isParent ? (
        <Box
          key={`seo-opts-${params?.value}`}
          sx={{
            textAlign: 'center',
            fontWeight: 'bold',
            width: '100%',
            height: '100%',
          }}
        >
          {params?.value}
        </Box>
      ) : (
        '–'
      )}
    </Box>
  )
}
export default SeoOptimizationCell
